import { z } from 'zod';

import { MAX_COMMUNICATION_LENGTH } from '@/constants/communication.ts';

import { InsuranceType } from '@/models/insurance.ts';

export const createDcCommunicationRequestSchema = z.object({
    patient_id: z.string().min(1),
    content: z.string().trim().min(1).max(MAX_COMMUNICATION_LENGTH),
    dc_calendar_id: z.string().min(1),
    insurance_type: z.enum(InsuranceType),
    date: z.iso.datetime(),
});

export type CreateDcCommunicationRequest = z.infer<typeof createDcCommunicationRequestSchema>;

export const createDcCommunicationResponseSchema = z.object({
    data: z.object({
        activity_id: z.string(),
        casefolder_id: z.string().optional(),
    }),
});

export type CreatedDcCommunication = z.infer<typeof createDcCommunicationResponseSchema>['data'];
